<template>
  <div :class="$vuetify.breakpoint.mdAndUp ? 'header desktop' : 'header mobile'">
    <router-link to="/">
      <img
        v-if="$vuetify.breakpoint.mdAndUp"
        width="248"
        height="28"
        src="@/assets/img/campaign/export-voucher/logo.png"
        alt="header" />
      <img v-else width="170" height="20" src="@/assets/img/campaign/export-voucher/logo-mobile.png" alt="header" />
    </router-link>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  components: {
    RouterLink,
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 64px;
}

.desktop {
  padding: 16px 24px;
}

.mobile {
  display: flex;
  align-items: center;

  padding: 16px;
}
</style>
